import { useState } from 'react';
import InfoFilled from 'src/components/Icons/InfoFilled';
import { SwiftToggleSwitch } from 'src/components/TradeForm/SwiftToggleSwitch';
import useCurrentSettings from 'src/hooks/useCurrentSettings';
import { cj } from 'src/utils/classNames';

export default function SwiftEnableMessage() {
	const [isToggleEnabled, setIsToggleEnabled] = useState(false);
	const [, updateSettings] = useCurrentSettings();

	const handleToggleChange = () => {
		setIsToggleEnabled(true);
		updateSettings({ swiftEnabled: true });
	};

	return (
		<div
			className={cj(
				'flex items-center justify-between gap-x-sm sm:gap-x-2xl',
				'rounded-sm bg-stroke-divider px-md py-sm typo-t4 text-text-default'
			)}
		>
			<div className="flex items-center gap-x-sm">
				<InfoFilled className="shrink-0" size={16} />
				<span className="hyphens-auto">
					Fastest order execution with 0 gas fees
				</span>
			</div>

			<SwiftToggleSwitch
				className="shrink-0"
				value={isToggleEnabled}
				onChange={handleToggleChange}
			/>
		</div>
	);
}
